module.exports = __webpack_public_path__ + "static/media/Hover2_MobileAlabama.ba74fcab.png";